var map = {
	"./iconAdd.vue": "7db2",
	"./iconAnalysis.vue": "4979",
	"./iconArrow.vue": "1e5a",
	"./iconCircle.vue": "c4b9",
	"./iconClose.vue": "2a7e",
	"./iconDelete.vue": "e675",
	"./iconEdit.vue": "14dc",
	"./iconEmpty.vue": "b91c",
	"./iconEyeDropper.vue": "7f77",
	"./iconFeedback.vue": "9290",
	"./iconFlag.vue": "bc87",
	"./iconFlagEnglish.vue": "d2cb",
	"./iconFlagGermany.vue": "0bbd",
	"./iconFlagJapan.vue": "b092",
	"./iconFlagNorway.vue": "aace",
	"./iconGuidance.vue": "9bc6",
	"./iconGuidanceText.vue": "1244",
	"./iconHamburgerBar.vue": "476f",
	"./iconLanguage.vue": "f7cf",
	"./iconLauncher.vue": "2de1",
	"./iconPause.vue": "2234",
	"./iconPlay.vue": "9cce",
	"./iconProcess.vue": "066d",
	"./iconReplay.vue": "b8fa",
	"./iconReviewBad.vue": "b327",
	"./iconReviewGood.vue": "2068",
	"./iconReviewOk.vue": "9c82",
	"./iconSearch.vue": "5707",
	"./iconToggle.vue": "42db",
	"./iconTrash.vue": "daa7",
	"./iconUpload.vue": "764a",
	"./iconView.vue": "5c5f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a20";